<template>
    <div class="eeg">
        <!-- 脑电 -->
        <div class="left">
            <div class="item">
                <p class="title"><i><img src="@/assets/Analysissoftware/HRV/ic_α@2x.png" alt=""></i>Alpha波(α)</p>
                <div class="chart">
                    <div ref="alphaWaves" style="width: 100%;height:330px"></div>
                </div>
            </div>
            <div class="item">
                <p class="title" style="background: #8159DE;"><i><img src="@/assets/Analysissoftware/HRV/ic_β@2x.png" alt=""></i>Beat波(β)</p>
                <div class="chart">
                    <div ref="beatWaves" style="width: 100%;height:330px"></div>
                </div>
            </div>
        </div>
        <div class="middle">
            <div class="item" style="padding: 0;">
                <p class="title"><i><img src="@/assets/Analysissoftware/HRV/ic_press@2x.png" alt=""></i>脑波数值</p>
                <span class="brainwave">
                    <p class="item"><label>δ</label> <span class="bgcolor01"></span></p>
                    <p class="item"><label>θ</label> <span class="bgcolor02"></span></p>
                    <p class="item"><label>α1</label> <span class="bgcolor03"></span></p>
                    <p class="item"><label>α2</label> <span class="bgcolor04"></span></p>
                    <p class="item"><label>β1</label> <span class="bgcolor05"></span></p>
                    <p class="item"><label>β2</label> <span class="bgcolor06"></span></p>
                    <p class="item"><label>γ1</label> <span class="bgcolor07"></span></p>
                    <p class="item"><label>γ2</label> <span class="bgcolor08"></span></p>
                </span>
            </div>
            <div class="item" style="margin-top: 10px;">
                <p class="title"><i><img src="@/assets/Analysissoftware/HRV/ic_energy@2x.png" alt=""></i>脑波能量</p>
                <p class="list" style="margin-top: 15px;"><label>Delta：</label>{{ EegInfo.delta }}</p>
                <p class="list"><label>Theata：</label>{{ EegInfo.theta }}</p>
                <p class="list"><label>低频alpha：</label>{{ EegInfo.lowAlpha }}</p>
                <p class="list"><label>高频alpha：</label>{{ EegInfo.higAlpha }}</p>
                <p class="list"><label>低频beta：</label>{{ EegInfo.lowBeta }}</p>
                <p class="list"><label>高频beta：</label>{{ EegInfo.higBeta }}</p>
                <p class="list"><label>低频gamma：</label>{{ EegInfo.lowGamma }}</p>
                <p class="list"><label>高频gamma：</label>{{ EegInfo.higGamma }}</p>
            </div>
        </div>
        <div class="right">
            <div class="Basicinfor">
                <label class="title">用户基本信息</label>
                <p class="item">部门：{{EegInfo.deptName}}</p>
                <p class="item">姓名：{{EegInfo.realName}}</p>
                <p class="item">性别：{{EegInfo.sex}}</p>
                <p class="item">年龄：{{EegInfo.age}}</p>
            </div>
            <div class="mentality">
                <p class="title"><i><img src="@/assets/Analysissoftware/HRV/ic_mentality@2x.png" alt=""></i>精神状态</p>
                <div class="items">
                    <i class="ic_concentrate"><img src="@/assets/Analysissoftware/HRV/ic_concentrate@2x.png"></i>
                    <p>
                        <span>集中度</span>
                        <label>{{EegInfo.attention}}</label>
                    </p>
                </div>
                <div class="items">
                    <i class="ic_concentrate"><img src="@/assets/Analysissoftware/HRV/ic_relax@2x.png"></i>
                    <p style="color: #9FE635;">
                        <span>放松度</span>
                        <label>{{EegInfo.meditation}}</label>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    data() {
        return {
            userId:JSON.parse(sessionStorage.getItem('xinxi')).UserID,
            EegInfo:{},
            time:null
        }
    },
    created(){
        this.getEegInfo();
    },
    mounted() {
        var _this=this;
        setTimeout(() => {
            _this.time=setInterval(() => {
                _this.getEegInfo();
            }, 1000);
        }, 2000);
    },
    methods: {
        getEegInfo(){
            this.$Http_Post('/bioassay/soft/getEegInfo',{userId:this.userId}).then(res=>{
                if(res.Code==0){
                    this.EegInfo=res.Data;
                    this.alphaWaves(res.Data.alphaWaves);
                    this.beatWaves(res.Data.beatWaves)
                }else{
                    this.$message.error(res.Message);
                }
                console.log(res)
            });
        },
        alphaWaves(data){
            var Xdata=[];
            for(let item in data){
                Xdata.push(item);
            }
            var myChart = this.$echarts.init(this.$refs.alphaWaves);
            var option = {
                tooltip: { },
                grid: {
                    top:30,
                    left: 30,  
                    right: 30,
                    bottom:30
                },  
                xAxis: {
                    type: 'category',
                    data:Xdata,
                    axisLine: {lineStyle: {color: '#fff'}},
                },
                yAxis: {
                    type: 'value',
                    axisLine: {lineStyle: {color: '#fff'}},
                },
                series:[
                {
                    name:'Alpha波(α)',
                    data: data,
                    type: 'line',
                    smooth: true,
                    color: '#1FA1CC'  
            
                }
                ]
            };

            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        },
        beatWaves(data){
            var myChart = this.$echarts.init(this.$refs.beatWaves);
            var option = {
                tooltip: { },
                grid: {
                    top:30,
                    left: 30,  
                    right: 30,
                    bottom:30
                },  
                xAxis: {
                    type: 'category',
                    data: [],
                    axisLine: {lineStyle: {color: '#fff'}},
                },
                yAxis: {
                    type: 'value',
                    axisLine: {lineStyle: {color: '#fff'}},
                },
                series:[
                {
                    name:'Beat波(β)',
                    data:data,
                    type: 'line',
                    smooth: true,
                    color: '#1FA1CC'  
            
                }
                ]
            };

            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        }
    },
    destroyed(){
        clearInterval(this.time);
    }
}
</script>
<style scoped>
img{width: 100%;display:block;}
.eeg{background:#291713;display: flex;min-height: 100%;padding: 15px;}
.eeg .left{flex: auto;}
.eeg .left .item{background: #3F5261;margin: 0 0 10px;}
.eeg .left .item .title{background: #1F3E8C;color:#fff;font-size: 20px;display: flex;padding: 5px 10px;}
.eeg .left .item .title i{width:30px;display: inline-block;margin-right: 5px;}
.eeg .left .item .chart{background: #372C26;}
.eeg .middle{width: 240px;margin:0 10px;}
.eeg .middle .item{background: rgba(255, 255, 255, 0.05);padding: 0 0 10px;}
.eeg .middle .item .title{background: #1F3E8C;color: #9FE635;font-size:20px;display: flex;padding: 3px 10px;}
.eeg .middle .item .title i{width: 30px;display: inline-block;margin-right: 12px;}
.eeg .middle .item .brainwave{display: block;padding:20px 0;}
.eeg .middle .item .brainwave .item{margin: 10px 0;background:none;padding: 0;display: flex;align-items: center;justify-content: space-evenly;}
.eeg .middle .item .brainwave .item label{color: #fff;}
.eeg .middle .item .brainwave .item span{height: 17px;width: 200px;display: inline-block;}
.eeg .middle .item .list{background: url("../../../assets/Analysissoftware/bg_rectangle@2x.png") no-repeat;background-size: 100% 100%;margin:5px 20px;color:#00BAAD;font-size: 30px;text-align: center;line-height: 40px;position: relative;text-indent: 30px}
.eeg .middle .item .list label{color: #fff;font-size: 14px;position: absolute;top: 50%;left:-20px;transform: translate(0,-50%);}
.eeg .right{width:240px;display: inline-block;}
.eeg .right .Basicinfor{background:url("../../../assets/Analysissoftware/bg_personal@2x.png") no-repeat;height:360px;background-size: 100% 100%;width: 240px;}
.eeg .right .Basicinfor .title{font-size: 22px;color: #fff;display: block;text-align: right;padding:5px 20px 20px 0;}
.eeg .right .Basicinfor .item{font-size: 18px;color: #43B8D9;padding: 15px 0 0 20px;}
.eeg .right .startBtn{width: 100%;margin: 10px 0;}
.eeg .right .mentality{background: rgba(255, 255, 255, 0.05);margin-top: 10px;padding-bottom: 30px;}
.eeg .right .mentality .title{background: #1F3E8C;color: #9FE635;font-size:20px;display: flex;padding: 3px 10px;}
.eeg .right .mentality .title i{width: 30px;display: inline-block;margin-right: 12px;}
.eeg .right .mentality .items{background: url("../../../assets/Analysissoftware/bg_square@2x.png") no-repeat;background-size: 100% 100%;margin:28px 20px 0;padding: 20px 0;display: flex;align-items: center;justify-content: center;}
.eeg .right .mentality .items .ic_concentrate{width: 50px;display: inline-block;}
.eeg .right .mentality .items p{color: #239FC2;display: grid;margin-left: 5px;}
.eeg .right .mentality .items p span{font-size: 22px;}
.eeg .right .mentality .items p label{font-size: 44px;font-weight: bold;}
.eeg .bgcolor01{background: #FF8D1A;}
.eeg .bgcolor02{background: #43CF7C;}
.eeg .bgcolor03{background: #00BAAD;}
.eeg .bgcolor04{background: #00BAAD;}
.eeg .bgcolor05{background: #D4C43B;}
.eeg .bgcolor06{background: #D4C43B;}
.eeg .bgcolor07{background: #7948EA;}
.eeg .bgcolor08{background: #7948EA;}
</style>